import { z } from 'zod'

const jsonObject = z.record(z.unknown())

export const tcpmachinesession0postPostScreenTruthMachineSessionResponseSchema = jsonObject
export type tcpmachinesession0postPostScreenTruthMachineSessionResponse = z.infer<typeof tcpmachinesession0postPostScreenTruthMachineSessionResponseSchema>
